import { render, staticRenderFns } from "./FreeWelfare.vue?vue&type=template&id=5a956423&scoped=true&"
import script from "./FreeWelfare.vue?vue&type=script&lang=js&"
export * from "./FreeWelfare.vue?vue&type=script&lang=js&"
import style0 from "./FreeWelfare.vue?vue&type=style&index=0&id=5a956423&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a956423",
  null
  
)

export default component.exports